/**
 * 用户退出全屏后短延迟自动再次请求全屏（无弹窗、不计次、不交卷）。
 * 使用 screenfull 的 change 事件，与 requestFullscreen 使用同一套前缀逻辑。
 */
import screenfull from "screenfull";
import { requestFullscreen, isFullscreen } from "./fullscreen.js";

const REENTER_DELAY_MS = 300;

/**
 * @param {{ getActive: () => boolean }} ctx
 * @returns {{ attach: () => void; detach: () => void }}
 */
export function createFullscreenEscapeGuard(ctx) {
  const handler = () => {
    if (!ctx.getActive()) return;

    if (!isFullscreen()) {
      setTimeout(async () => {
        if (!ctx.getActive()) return;
        await requestFullscreen();
      }, REENTER_DELAY_MS);
    }
  };

  return {
    attach() {
      if (screenfull.isEnabled && typeof screenfull.on === "function") {
        screenfull.on("change", handler);
      }
    },
    detach() {
      if (screenfull.isEnabled && typeof screenfull.off === "function") {
        screenfull.off("change", handler);
      }
    },
  };
}
